var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "分类",
      "labelCol": {
        xs: {
          span: 8
        },
        sm: {
          span: 2
        }
      },
      "wrapperCol": {
        xs: {
          span: 16
        },
        sm: {
          span: 22
        }
      }
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: _vm.queryParam.orderBy,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "orderBy", $$v);
      },
      expression: "queryParam.orderBy"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": "time"
    }
  }, [_vm._v("\n            科普名家\n          ")]), _c('a-radio-button', {
    attrs: {
      "value": "view"
    }
  }, [_vm._v("\n            科普达人\n          ")])], 1)], 1), _c('a-divider'), _vm.loading ? _c('a-skeleton') : _vm._e(), _c('a-list', {
    attrs: {
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item, index) {
        return _c('a-list-item', {}, [_c('a-card', {
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('a-row', {
          attrs: {
            "type": "flex",
            "gutter": 24
          }
        }, [_c('a-col', {
          staticClass: "animate__animated animate__fadeIn",
          attrs: {
            "span": 8
          }
        }, [_c('PhotoCard', {
          attrs: {
            "img": item.cmsCover_url
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v("\n                  " + _vm._s(item.cmsTitile) + "\n                ")])])], 1), _c('a-col', {
          staticClass: "animate__animated animate__slideInRight",
          attrs: {
            "span": 16
          }
        }, [_c('div', {
          staticClass: "people"
        }, [_c('a', [_c('h3', {
          staticClass: "name"
        }, [_vm._v(_vm._s(item.cmsTitile))]), _c('a-tag', {
          staticClass: "title",
          attrs: {
            "color": "blue"
          }
        }, [_vm._v("院士")])], 1), _c('p', {
          staticClass: "people-desc"
        }, [_vm._v("\n                  " + _vm._s(item.cmsDesc) + "\n                ")])])])], 1)], 1)], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };